<div class="error-message">
  <ng-container *ngIf="show">
    <i class="fas fa-exclamation-triangle"></i>
    <span class="message-text">
      <ng-content></ng-content>
    </span>
  </ng-container>
</div>
